;(function () {
  angular.module('contrast.auth').controller('LoginCtrl', LoginCtrl)

  function LoginCtrl(
    $log,
    $scope,
    $rootScope,
    $location,
    $q,
    $window,
    $timeout,
    $translate,
    permissions,
    LoginFactory,
    AuthFactory,
    CommonFactory,
    ContrastLicenseFactory,
    tsvApiConfig,
    UserService,
    ErrorService,
    AuthService,
    GlobalService,
    URLHistoryService,
    LOGIN_EVENTS,
    ProfileService,
    LoginService,
    GridToggleService,
    ADMIN_PORTAL_URL
  ) {
    'ngInject'

    angular.extend($scope, {
      loggingIn: false,
      model: {
        username: '',
        password: '',
        show_forgot_password: false,
        tsv: false,
        show_sso: false,
        uses_sso: undefined,
        sso_step: 1
      },
      alerts: [],
      alertsSuccess: []
    })

    angular.extend($scope, {
      login: login,
      backToUsername: backToUsername
    })

    function init() {
      getInformation()
    }

    var searchObject = $location.search()
    if (searchObject['logout']) {
      $scope.alertsSuccess[0] = {
        msg: $translate.instant('action_loggedOutSuccessfully')
      }
    } else if (searchObject['locked']) {
      addErrorMessage(
        $translate.instant('validation_invalidLoginLockedAccount')
      )
    } else if (searchObject['unauthenticated']) {
      $scope.alerts[0] = {
        msg: $translate.instant('validation_invalidLoginSessionExpired')
      }
    } else if (searchObject['failedMaxTsvAttempts']) {
      $scope.alerts[0] = {
        msg: $translate.instant(
          'validation_invalidLoginInvalidCodesAccountBlocked'
        )
      }
    } else if (searchObject['failedMaxAttempts']) {
      $scope.alerts[0] = {
        msg: $translate.instant(
          'validation_invalidLoginFailedBackupCodesAttempts'
        )
      }
    } else if (searchObject['failedSSO']) {
      $scope.alerts[0] = {
        msg: $translate.instant('validation_invalidLoginFailedSSOLogin')
      }
    }

    function login(skipSSOCheck) {
      GridToggleService.toggleOldGridOn()
      GridToggleService.removeOldGridLibToggle()
      if (
        $scope.model.show_sso &&
        $scope.model.sso_step == 1 &&
        !skipSSOCheck
      ) {
        return checkSSO($scope.model.username).then(function () {
          if ($scope.model.uses_sso) {
            $scope.login(true)
          } else {
            $scope.model.sso_step = 2
            $timeout(function () {
              $scope.$broadcast(LOGIN_EVENTS.FOCUS_PASSWORD)
            }, 100)
          }
        })
      } else {
        $scope.loggingIn = true
        var deferred = $q.defer()
        clearMessages()

        if ($scope.model.uses_sso) {
          $scope.model.password = null
        }

        /*
         CONTRAST-11687 - check for a valid license first then try to authenticate
         */
        $log.info('checking if license is active')
        ContrastLicenseFactory.isLicenseActive()
          .then(function () {
            $log.info('isLicenseActive resolve')
            $log.info('attempting login')

            LoginFactory.login(
              $scope.model.username,
              $scope.model.password,
              $scope.model.uses_sso
            )
              .then(function (response) {
                $log.info('login resolve')
                var data = response.data

                if ($scope.model.uses_sso) {
                  $log.info('using sso')
                  if (data.entity_id != null) {
                    $log.info('no entity_id')
                    $scope.loggingIn = false
                    $window.location.href =
                      '/Contrast/saml/login?idp=' + data.entity_id
                    deferred.resolve('success')
                    return
                  } else {
                    $log.info('entity_id exists')
                    $scope.loggingIn = false
                    addErrorMessage(getErrorMessage(data.messages[0]))
                    return
                  }
                }

                if (data.success) {
                  $log.info('login success')
                  // Don't mark loggingIn as false, just let it spin (only mark false on error)
                  var toggleEnabled = data.toggle_enabled

                  permissions
                    .loadUserSettings(false)
                    .then(function () {
                      $log.info('loadUserSettings resolve')
                      //if there are no allowed orgs and toggle allowed, redirect if available
                      if (
                        angular.isArray($rootScope.allowed_organizations) &&
                        $rootScope.allowed_organizations.length == 0
                      ) {
                        $log.info(
                          'loadUserSettings allowed_organizations is an empty array'
                        )
                        if (toggleEnabled) {
                          $log.info('toggle is enabled')
                          AuthFactory.togglePortal(false)
                            .then(function () {
                              $log.info('toggle portal resolve')
                              // redirecting to portal...
                              URLHistoryService.clearPreviousUrl()
                              $window.location.href = ADMIN_PORTAL_URL
                            })
                            .catch(function (response) {
                              $log.error('toggle portal reject')
                              var errorMsg = $translate.instant(
                                'validation_invalidLoginFailedPortalRedirection'
                              )
                              $log.error(errorMsg, response)
                              ErrorService.processError(response)
                              addErrorMessage(errorMsg)

                              clear()
                              deferred.resolve('failed')
                            })
                        } else {
                          var errorMsg = $translate.instant(
                            'validation_invalidLoginNoOrganizationAssigned'
                          )
                          $log.error(errorMsg)
                          addErrorMessage(errorMsg)
                          clear()
                          deferred.resolve('failed')
                          $scope.loggingIn = false
                        }
                      } else {
                        permissions
                          .getUser()
                          .then(function () {
                            $log.info('getDefaultOrganization')
                            permissions
                              .getDefaultOrganization()
                              .then(function () {
                                $log.info('getDefaultOrganization resolve')
                                if ($scope.model.tsv) {
                                  $log.info('tsv truthy')
                                  tsvApiConfig
                                    .getTsvLoginValues()
                                    .then(function (response) {
                                      $log.info('getTsvLoginValues resolve')
                                      $scope.model = {
                                        username: '',
                                        password: ''
                                      }
                                      if ($scope.form) {
                                        $scope.form.$setPristine()
                                      }
                                      if (response.data.tsv_trusted_device) {
                                        $location.path(
                                          UserService.buildUrl('/dashboard'),
                                          true
                                        )
                                      } else if (response.data.tsv_login) {
                                        AuthService.setInitializeTsv(true)
                                        $location.path('tsv/verification', true)
                                      } else if (
                                        response.data.tsv_setup ||
                                        response.data.tsv_setup_optional
                                      ) {
                                        UserService.setTsvRequired(
                                          response.data.tsv_setup
                                        )
                                        $location.path('tsv/setup', true)
                                      } else {
                                        var previousUrl =
                                          URLHistoryService.getPreviousUrl()
                                        if (previousUrl) {
                                          URLHistoryService.redirectToNewUiOrPreviousUrl(
                                            previousUrl,
                                            true
                                          )
                                        } else {
                                          $location.path(
                                            UserService.buildUrl('/dashboard'),
                                            true
                                          )
                                        }
                                      }

                                      AuthService.setAuthenticated(true)
                                      deferred.resolve('success')
                                    })
                                    .catch(function (response) {
                                      if (
                                        response.data.status === 403 &&
                                        UserService.getCurrentOrganization()
                                          .rbac_enforce_assess
                                      ) {
                                        addErrorMessage(
                                          $translate.instant(
                                            'validation_invalidLoginRbacPermissions'
                                          )
                                        )
                                      } else {
                                        // couldn't load tsv login properties...
                                        addErrorMessage(
                                          $translate.instant(
                                            'validation_invalidLoginTsvProperties'
                                          )
                                        )
                                      }
                                      ErrorService.processErrorGA(
                                        _getAlertMessage()
                                      )
                                      clear()
                                      deferred.resolve('failed')
                                    })
                                } else {
                                  $log.info('tsv falsy')
                                  $scope.model = { username: '', password: '' }
                                  $scope.form.$setPristine()

                                  var previousUrl =
                                    URLHistoryService.getPreviousUrl()
                                  if (previousUrl) {
                                    redirectToNewUiOrPreviousUrl(
                                      previousUrl,
                                      false
                                    )
                                  } else {
                                    $location.path(
                                      UserService.buildUrl('/dashboard'),
                                      true
                                    )
                                  }

                                  URLHistoryService.clearPreviousUrl()
                                  AuthService.setAuthenticated(true)
                                  deferred.resolve('success')
                                }
                              })
                              .catch(function (response) {
                                var errorMessage = $translate.instant(
                                  'validation_invalidLoginErrorLoadDefaultOrganization'
                                )
                                $log.error(errorMessage)
                                $scope.loggingIn = false
                                if (response.data.messages) {
                                  errorMessage = response.data.messages[0]
                                  addErrorMessage(errorMessage)
                                }
                                ErrorService.processErrorGA(errorMessage)

                                clear()
                                deferred.resolve('failed')
                              })
                          })
                          .catch(function (response) {
                            $log.error('loadUser catch ', response)
                            $scope.loggingIn = false
                          })
                      }
                    })
                    .catch(function (response) {
                      $log.error('loadUserSettings catch ', response)
                      $scope.loggingIn = false
                      if (response.blockSuperAdmin) {
                        addErrorMessage(
                          $translate.instant(
                            'validation_invalidLoginSuperAdminAccessDisabled'
                          )
                        )
                        deferred.resolve('failed')
                      } else if (
                        angular.isUndefined(response.data.organization)
                      ) {
                        // Error loading user settings
                        addErrorMessage(
                          $translate.instant(
                            'validation_invalidLoginUnableLoadUserSettings'
                          )
                        )
                        deferred.reject('failed')
                      } else {
                        var noOrgErrorMsg = $translate.instant(
                          'validation_invalidLoginNoOrganizationAssigned'
                        )
                        $log.error(noOrgErrorMsg)
                        addErrorMessage(noOrgErrorMsg)

                        deferred.resolve('failed')
                      }
                      ErrorService.processErrorGA(_getAlertMessage())

                      clear()
                      AuthService.setAuthenticated(false)
                    })
                } else {
                  $log.warn('login resolve, but failed')
                  $scope.loggingIn = false

                  if (data.messages) {
                    addErrorMessage(getErrorMessage(data.messages[0]))
                    ErrorService.processErrorGA(_getAlertMessage())
                  }

                  clear()
                  deferred.resolve('failed')
                }
              })
              .catch(function (response) {
                $log.error('login reject: ', response)
                $scope.loggingIn = false

                if (
                  angular.isArray(response.data.messages) &&
                  angular.isDefined(response.data.messages[0])
                ) {
                  addErrorMessage(getErrorMessage(response.data.messages[0]))
                } else {
                  addErrorMessage(
                    $translate.instant(
                      'validation_invalidLoginUnableAuthenticate'
                    )
                  )
                }

                ErrorService.processErrorGA(_getAlertMessage())
                deferred.reject('failed')
              })
          })
          .catch(function (response) {
            $log.error('isLicenseActive reject: ', response)
            ErrorService.processErrorGA('isLicenseActive reject: ', response)
            AuthService.setAuthenticated(false)
            $location.path('pages/expired', true)
          })

        return deferred.promise.then(function (response) {
          $log.info('deferred resolve ', response)
          // has new user onboarding already been completed?
          if (!ProfileService.getNewUserOnboardingPreference()) {
            LoginService.setIsAfterFirstLogin(true)
          }
          return response
        })
      }
    }

    function checkSSO(userUid) {
      return CommonFactory.getSaml(userUid).then(
        function () {
          $scope.model.uses_sso = true
        },
        function () {
          $scope.model.uses_sso = false
        }
      )
    }

    function getInformation() {
      return CommonFactory.getInformation().then(
        function (response) {
          $scope.model.show_breadcrumbs = response.data.tsv_breadcrumbs
          $scope.model.tsv = response.data.tsv_flag

          $scope.model.show_sso = response.data.saml_enabled // feature

          GlobalService.setManagingUsers(response.data.show_forgot_password)
          $scope.model.show_forgot_password = response.data.show_forgot_password
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function addErrorMessage(message) {
      $scope.alerts[0] = { msg: message }
      $scope.alertsSuccess = []
    }

    function _getAlertMessage() {
      return angular.isUndefined($scope.alerts[0]) ? '' : $scope.alerts[0].msg
    }

    function clear() {
      AuthService.clearCookies()
      AuthService.setAuthenticated(false)
      $scope.model.password = ''
      $scope.form.password.$setPristine()
    }

    function clearMessages() {
      $scope.alerts = []
      $scope.alertsSuccess = []

      $location.search('logout', null)
      $location.search('unauthenticated', null)
      $location.search('failedMaxAttempts', null)
    }

    function backToUsername() {
      $scope.model.sso_step = 1
      $scope.$broadcast(LOGIN_EVENTS.FOCUS_USERNAME)
    }

    function getErrorMessage(message) {
      switch (message) {
        case 'auth.userlocked':
          return 'Account locked'

        case 'auth.userinactive':
          return 'Account inactive'

        default:
          return message
      }
    }

    init()
  }
})()
